var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 57,
    viewBox: "0 0 67 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6575_41590)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6575_41590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7034 55.6938L20.0768 56.4765C19.1629 56.6307 18.2972 56.011 18.1429 55.0919L14.9678 36.1126L22.9041 34.7695L26.0791 53.7488C26.2334 54.6689 25.6173 55.5396 24.7034 55.6938Z",
    fill: "#00A868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.927 29.9013L47.8478 21.906L45.6112 16.1748L35.8638 14.3652L41.927 29.9013Z",
    fill: "#008E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1359 31.045L47.8477 21.9042L46.9525 19.6094L39.6245 27.1728L41.1359 31.045Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6244 26.9617C39.589 26.9617 39.5537 26.9488 39.5261 26.9231C39.4652 26.8688 39.4603 26.7749 39.5153 26.7136L44.6136 21.024C44.6676 20.9627 44.761 20.9578 44.8219 21.0131C44.8828 21.0675 44.8878 21.1614 44.8327 21.2226L39.7345 26.9123C39.704 26.9449 39.6647 26.9617 39.6244 26.9617Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8525 3.12502L48.7871 38.8283C49.2972 40.1358 48.0924 41.4602 46.7539 41.0648L27.8036 35.475L6.82985 43.754L0.766602 28.2179L21.7403 19.939L31.8494 2.87696C32.5628 1.67123 34.3425 1.8175 34.8525 3.12502Z",
    fill: "#00A868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5181 19.8932C45.1608 21.5407 46.63 22.3857 47.8465 21.9054L45.5971 16.1406C44.3805 16.6209 43.8754 18.2457 44.5181 19.8932Z",
    fill: "#00A868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27441 34.2197C9.67279 37.8023 8.84045 41.6468 6.82985 43.7548L0.766602 28.2188C3.66654 28.3907 6.87702 30.6391 8.27441 34.2197Z",
    fill: "#42EC9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6816 33.0461C27.601 33.0461 27.5352 32.9808 27.5342 32.9008C27.5332 32.8187 27.5981 32.7515 27.6786 32.7496L44.643 32.461C44.7245 32.459 44.7913 32.5252 44.7933 32.6063C44.7943 32.6883 44.7294 32.7555 44.6489 32.7575L27.6845 33.0461C27.6836 33.0461 27.6826 33.0461 27.6816 33.0461Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6192 26.5581C66.6074 26.5581 66.5946 26.5561 66.5818 26.5531L55.2936 23.6001C55.215 23.5793 55.1678 23.4983 55.1884 23.4192C55.2091 23.3402 55.2887 23.2927 55.3683 23.3135L66.6565 26.2665C66.7351 26.2873 66.7823 26.3683 66.7617 26.4474C66.744 26.5146 66.684 26.5581 66.6192 26.5581Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3415 15.828C54.2825 15.828 54.2265 15.7924 54.2039 15.7341C54.1745 15.658 54.2118 15.572 54.2875 15.5424L65.1473 11.264C65.2229 11.2344 65.3084 11.272 65.3379 11.3481C65.3674 11.4242 65.33 11.5101 65.2544 11.5398L54.3956 15.8181C54.3779 15.825 54.3592 15.828 54.3415 15.828Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7537 41.0663L27.8034 35.4746L23.335 37.2387L23.4962 38.308L23.3979 38.3446C23.4254 38.4177 23.392 38.4978 23.3203 38.5304L17.7828 41.0337L23.1178 39.7391C23.1925 39.7213 23.2682 39.7638 23.2918 39.8369C23.3164 39.911 23.28 39.9901 23.2083 40.0197L17.9489 42.2187L22.3975 41.263C22.4771 41.2462 22.5557 41.2976 22.5725 41.3777C22.5901 41.4577 22.539 41.5358 22.4594 41.5536L16.4443 42.8453C16.4345 42.8473 16.4237 42.8482 16.4139 42.8482C16.35 42.8482 16.292 42.8077 16.2734 42.7445C16.2498 42.6713 16.2871 42.5923 16.3569 42.5636L21.3667 40.4694L16.3117 41.6959C16.239 41.7137 16.1623 41.6722 16.1377 41.6C16.1132 41.5269 16.1476 41.4478 16.2173 41.4162L21.2517 39.1411L15.8125 41.1592L15.6592 40.2688L8.85693 42.954C9.421 42.2582 9.81899 41.4429 9.95461 40.4378L27.0988 33.6699L47.0171 34.2945L48.7869 38.8288C49.2969 40.1364 48.0921 41.4607 46.7537 41.0663Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.098 10.5248C50.0695 10.5248 50.041 10.5169 50.0155 10.4991C49.9477 10.4536 49.93 10.3617 49.9752 10.2935L56.4905 0.563705C56.5357 0.495513 56.6281 0.477723 56.6949 0.523185C56.7627 0.568647 56.7804 0.660559 56.7352 0.728751L50.2199 10.4586C50.1914 10.502 50.1452 10.5248 50.098 10.5248Z",
    fill: "#1D232A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6575_41590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 56,
    fill: "white",
    transform: "translate(0.766602 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6575_41590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 56,
    fill: "white",
    transform: "translate(0.766602 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.83ca2cf4a0a71a89faefc88623fffa49.svg";
export { ForwardRef as ReactComponent };